import _ from 'lodash'
import i18n from '@/locales'
import { PRIORITY_MAP, WORKFLOW_TYPES, PROCESS_TYPES_OPTS } from '@/constants/workflow'
import { getWorkflowParamter } from '@/utils/utils'
import store from '@/store'
import { getCopyWithContentTableColumn } from '@/utils/common/tableColumn'
import { strategyColumn, getStrategyInfo } from '@Monitor/views/commonalert/utils'
import BrandIcon from '@/sections/BrandIcon'
import { alertResourceTypeMap } from '../constants'
import { statusMap, auditStatusMap } from './index'

const getParamter = (variables) => {
  if (variables['server-create-paramter']) {
    return JSON.parse(variables['server-create-paramter'])
  } else {
    return getWorkflowParamter(variables)
  }
}
export const getProcessDefinitionNameTableColumn = ({ field = 'process_definition_name', title = i18n.t('common_375') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (row.process_definition_key === 'apply-internal-resource' || (row.process_definition_id || '').indexOf('apply-internal-resource') !== -1) {
        const rs = getWorkflowParamter(row.variables)
        const { process_type = {} } = rs
        return i18n.t(`system_process_type.${process_type.id}`)
      } else {
        // 购物车工单
        if (row.variables?.process_definition_key === WORKFLOW_TYPES.EXECUTE_RESOURCE_ORDER_SET) {
          return i18n.t('common.workflow.order_set')
        }
        return _.get(row, field, '-')
      }
    },
  }
}

export const getResourceSourceTableColumn = ({ field = 'source', title = i18n.t('wz_workflow_form.labels.source') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (row.process_definition_key === 'apply-internal-resource' || (row.process_definition_id || '').indexOf('apply-internal-resource') !== -1) {
        const rs = getParamter(row.variables)
        const { process_id } = rs
        if (process_id) {
          return `${i18n.t('system.irs_orders')}-${process_id}`
        } else {
          return i18n.t('wz_workflow_form.type')
        }
      } else {
        return ''
      }
    },
    slots: {
      default: ({ row }, h) => {
        if (row.process_definition_key === 'apply-internal-resource' || (row.process_definition_id || '').indexOf('apply-internal-resource') !== -1) {
          const rs = getParamter(row.variables)
          const { process_id } = rs
          const ret = []
          if (process_id) {
            ret.push(
              <list-body-cell-wrap copy row={{ process_id }} field="process_id" hideField={true}>
                {i18n.t('system.irs_orders')}-{process_id}
              </list-body-cell-wrap>,
            )
          } else {
            ret.push(<div>{i18n.t('wz_workflow_form.type')}</div>)
          }
          return ret
        } else {
          return '-'
        }
      },
    },
  }
}

export const getAreaTableColumn = ({ field = 'area', title = i18n.t('wz_workflow_form.labels.country') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      let f = field
      if (row.process_instance?.process_definition_key === 'apply-internal-resource' || row.process_definition_key === 'apply-internal-resource') {
        f = 'variables.project_name'
      }
      return _.get(row, f, '')
    },
    slots: {
      default: ({ row }, h) => {
        let f = field
        if (row.process_instance?.process_definition_key === 'apply-internal-resource' || row.process_definition_key === 'apply-internal-resource') {
          f = 'variables.project_name'
        }
        const project = _.get(row, f, '-')
        return [
          <list-body-cell-wrap copy row={row} hideField={true} message={project}>
            {project}
          </list-body-cell-wrap>,
        ]
      },
    },
  }
}

const openResourceColumns = [
  {
    title: i18n.t('system.resource_type'),
    field: 'resource_type',
    formatter: ({ row }) => {
      return i18n.te(`wz_workflow_form.resource_types.${row.resource_type}`) ? i18n.t(`wz_workflow_form.resource_types.${row.resource_type}`) : row.resource_type
    },
  },
  {
    title: i18n.t('system.instance_name'),
    field: 'instance_name',
    formatter: ({ row }) => {
      return row.instance_name
    },
  },
  {
    title: i18n.t('system.instance_id'),
    field: 'instance_code',
    formatter: ({ row }) => {
      return row.instance_code || row.instance_id
    },
  },
  {
    title: 'IP',
    field: 'ip',
    slots: {
      default: ({ row }, h) => {
        return row.ip
      },
    },
  },
  {
    title: i18n.t('common_386'),
    field: 'details',
    formatter: ({ row }) => {
      const ret = []
      if (row.details) {
        const keys = Object.keys(row.details)
        const rows = keys.map(item => {
          return item + ': ' + row.details[item]
        })
        ret.push(...rows)
      }
      return ret.join(',')
    },
    slots: {
      default: ({ row }, h) => {
        const ret = []
        if (row.details) {
          const keys = Object.keys(row.details)
          const rows = keys.map(item => {
            return <a-tag class="mb-2">{item + ': ' + row.details[item]}</a-tag>
          })
          ret.push(<div>{...rows}</div>)
        }
        return ret
      },
    },
  },
]

const getOpenResourceDatas = ({ row }) => {
  const rs = getParamter(row.variables)
  const { process_type = { id: '1' } } = rs
  if (process_type.id === '1') {
    const { openResourceInfo = {} } = rs
    const { resources = [] } = openResourceInfo
    return resources
  } else if (process_type.id === '11') {
    const { changeResourceInfo = {} } = rs
    const { resources = [] } = changeResourceInfo
    return resources
  } else if (process_type.id === '21') {
    const { deleteResourceInfo = {} } = rs
    const { resources = [] } = deleteResourceInfo
    return resources
  }
  return []
}

export const getOpenResourceTableColumns = () => {
  return {
    field: 'open_resource',
    title: i18n.t('system.open_resources'),
    slots: {
      default: ({ row }, h) => {
        if (row.process_instance?.process_definition_key === 'apply-internal-resource' || row.process_definition_key === 'apply-internal-resource') {
          const datas = getOpenResourceDatas({ row })
          const resources = getOpenResourceDatas({ row })
          const columns = openResourceColumns
          return [<list-body-cell-popover text={i18n.t('common_701', [resources.length])} min-width="600px">
            <vxe-grid size="mini" border showOverflow={false} row-config={{ isHover: true }} column-config={{ resizable: false }} columns={columns} data={datas} />
          </list-body-cell-popover>]
        } else {
          return '-'
        }
      },
    },
    formatter: ({ row }) => {
      const resources = getOpenResourceDatas({ row })
      return resources.length
    },
  }
}

export const internalResourceColumns = () => {
  const ret = []
  if (store.getters.workflow.enableApplyInternalResource) {
    ret.push(getResourceSourceTableColumn())
    ret.push(getAreaTableColumn())
    ret.push(getOpenResourceTableColumns())
    ret.push(getInternalResourceProjectTableColumn())
  } else {
    ret.push(getResourceNameTableColumn())
    ret.push(getResourceTypeTableColumn())
    ret.push(getResourceProjectTableColumn({
      field: 'variables.resource_project_name',
      title: i18n.t('dictionary.project'),
    }))
  }
  return ret
}

export const getResourceNameTableColumn = ({ field = 'resource_name', title = i18n.t('common_151') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (!row.variables) return ''
      const rs = getParamter(row.variables)
      let name = rs.generate_name || rs.name
      if (Array.isArray(rs)) {
        name = rs.map((item) => item.name).join(',')
      }
      if (!name) {
        name = ''
      }
      if (row.process_definition_key === 'apply-internal-resource' || (row.process_definition_id || '').indexOf('apply-internal-resource') !== -1) {
        return ''
      } else {
        return name
      }
    },
    slots: {
      default: ({ row }, h) => {
        if (!row.variables) return '-'
        const rs = getParamter(row.variables)
        let name = rs.generate_name || rs.name
        if (Array.isArray(rs)) {
          name = rs.map((item) => item.name).join(',')
        }
        if (!name) {
          name = '-'
        }
        const ret = []
        if (row.process_definition_key === 'apply-internal-resource' || (row.process_definition_id || '').indexOf('apply-internal-resource') !== -1) {
          return '-'
        } else {
          ret.push(
            <list-body-cell-wrap copy row={row} hideField={true} message={name}>
              {name}
            </list-body-cell-wrap>,
          )
        }
        return ret
      },
    },
  }
}

export const getResourceTypeTableColumn = () => {
  return {
    field: 'resource_type',
    title: i18n.t('common.resource_type'),
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (!row.variables) return '-'
      const rs = getParamter(row.variables)
      const process_definition_key = row.process_definition_key || row.process_instance?.process_definition_key
      if ([WORKFLOW_TYPES.ALERT_EVENT, WORKFLOW_TYPES.ALERT_TICKET].includes(process_definition_key)) {
        if (rs.res_type) return i18n.te(`dictionary.${rs.res_type}`) ? i18n.t(`dictionary.${rs.res_type}`) : rs.res_type
      }
      if ([WORKFLOW_TYPES.EXECUTE_RESOURCE_ORDER_SET].includes(process_definition_key)) {
        return i18n.t('dictionary.compute')
      }
      const target = PROCESS_TYPES_OPTS.filter(v => v.value === process_definition_key)
      if (target.length && target[0].res_type) return i18n.te(`dictionary.${target[0].res_type}`) ? i18n.t(`dictionary.${target[0].res_type}`) : target[0].res_type
      return '-'
    },
  }
}

export const getResourceProjectTableColumn = ({ field = 'resource_project_name', title = i18n.t('common_310') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      return _.get(row, field, '-')
    },
    slots: {
      default: ({ row }, h) => {
        const project = _.get(row, field, '-')
        return [
          <list-body-cell-wrap copy row={row} hideField={ true } message={ project }>
            { project }
          </list-body-cell-wrap>,
        ]
      },
    },
  }
}

export const getInternalResourceProjectTableColumn = () => {
  return {
    field: 'project_name',
    title: i18n.t('wz_workflow_form.labels.project_name'),
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (!row.variables) return ''
      const rs = getParamter(row.variables)
      if (!rs.projectInfo) return '-'
      let value = rs.projectInfo?.project_name || ''
      const { project_type = { id: 'origin_project', name: i18n.t('wz_workflow_form.project_types.origin_project') } } = rs.projectInfo
      value += project_type.name ? `（${project_type.name}）` : ''
      return value
    },
    slots: {
      default: ({ row }, h) => {
        if (!row.variables) return ''
        const rs = getParamter(row.variables)
        if (!rs.projectInfo) return '-'
        let value = rs.projectInfo?.project_name || ''
        const { project_type = { id: 'origin_project', name: i18n.t('wz_workflow_form.project_types.origin_project') } } = rs.projectInfo
        value += project_type.name ? `（${project_type.name}）` : ''
        return [
          <list-body-cell-wrap copy row={row} hideField={true} message={value}>
            {value}
          </list-body-cell-wrap>,
        ]
      },
    },
  }
}

export const getInitiatorTableColumn = ({ field = 'initiator' } = {}) => {
  return {
    field,
    title: i18n.t('common_371'),
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      return _.get(row, field, '-')
    },
  }
}

export const getCommentTableColumn = ({ field = 'comment', title = i18n.t('common_438') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      const variables = row.variables
      if (variables.comment) {
        return variables.comment
      }
      return '-'
    },
  }
}

export const getPriorityTableColumn = () => {
  return {
    field: 'priority',
    title: i18n.t('common.workflow_priority'),
    minWidth: 80,
    showOverflow: 'title',
    foramtter: ({ row }) => {
      const veriables = row.variables
      if (veriables.priority && PRIORITY_MAP[veriables.priority]) {
        return PRIORITY_MAP[veriables.priority].value
      }
      return '-'
    },
  }
}

export const getStateTableColumn = ({ field = 'state', title = i18n.t('common_372') } = { }) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      const statusObj = statusMap(row.process_definition_key)[row.state]
      return statusObj ? statusObj.text : ''
    },
    slots: {
      default: ({ row }, h) => {
        const statusObj = statusMap(row.process_definition_key)[row.state]
        if (statusObj) {
          return [
            <span style={{ color: statusObj.color }}>{statusObj.text}</span>,
          ]
        }
      },
    },
  }
}

export const getAuditStatusTableColumn = ({ field = 'audit_status', title = i18n.t('common_401') } = {}) => {
  return {
    field,
    title,
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (row.variables.audit_status) {
        const statusObj = auditStatusMap(row.process_definition_key)[row.variables.audit_status]
        if (row.process_definition_key === WORKFLOW_TYPES.CUSTOMER_SERVICE) {
          return row.audit_state
        }
        if (statusObj) {
          return statusObj.text
        }
      }
      return ''
    },
    slots: {
      default: ({ row }, h) => {
        if (row.variables.audit_status) {
          const statusObj = auditStatusMap(row.process_definition_key)[row.variables.audit_status]
          if (row.process_definition_key === WORKFLOW_TYPES.CUSTOMER_SERVICE) {
            return [
              <span style="color: #f6a100;">{row.audit_state}</span>,
            ]
          }
          if (statusObj) {
            return [
              <span style={{ color: statusObj.color }}>{statusObj.text}</span>,
            ]
          }
        }
      },
    },
  }
}

export const getStatusTableColumn = ({ field = 'status', title = i18n.t('common_402') } = {}) => {
  return {
    field,
    title,
    minWidth: 100,
    showOverflow: 'title',
    // sortable: true,
    formatter: ({ row }) => {
      const bizStatus = row.variables.biz_status
      if ((row.state === 'COMPLETED' || row.state === 'CUSTOM_TODO') && bizStatus) {
        const s = `status.workflowBiz.${bizStatus}`
        return i18n.te(s) ? i18n.t(s) : s
      }
      return '-'
    },
    slots: {
      default: ({ row }, h) => {
        const bizStatus = row.variables.biz_status
        const tooltip = <span class='ml-1'><a-tooltip title={i18n.t('workflow.biz_field')}><a-icon type="question-circle" /></a-tooltip></span>
        if ((row.state === 'COMPLETED' || row.state === 'CUSTOM_TODO') && bizStatus) {
          return [
            <div class="d-flex"><status status={bizStatus} statusModule={'workflowBiz'} />{bizStatus === 'fail' ? tooltip : null}</div>,
          ]
        }
        return '-'
      },
    },
    hidden: store.getters.workflow.enableApplyInternalResource,
  }
}

export const getAssigneeTableColumn = ({ field = 'assignee', title = i18n.t('common_399') } = {}) => {
  return {
    field,
    title,
    width: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      const assignees = []
      if (Array.isArray(row.tasks)) {
        row.tasks.forEach((item) => {
          if (!item.delete_reason) {
            assignees.push(item.assignee_displayname || item.assignee_name)
          }
        })
      } else {
        if (row.tasks && !row.delete_reason) {
          assignees.push(row.tasks.assignee_displayname || row.tasks.assignee_name)
        }
      }
      return assignees.length > 0 ? assignees.join(',') : '-'
    },
  }
}

export const getLevelTableColumn = () => {
  return {
    field: 'priority_level',
    title: i18n.t('system.text_315'),
    showOverflow: 'title',
    formatter: ({ row }) => {
      return row.variables.priority_level || '-'
    },
    slots: {
      default: ({ row }, h) => {
        if (!row.variables.priority_level) {
          return '-'
        }
        let color = 'cyan'
        if (row.variables.priority_level === 'P2') {
          color = 'pink'
        } else if (row.variables.priority_level === 'P1') {
          color = 'red'
        }
        return [h('a-tag', {
          props: {
            color,
          },
        }, row.variables.priority_level)]
      },
    },
  }
}

export const getAlertCountTableColumn = () => {
  return {
    field: 'alert_record_count',
    title: i18n.t('monitor.alert_count'),
    minWidth: 80,
    showOverflow: 'title',
    formatter: ({ row }) => {
      return row.variables.alert_record_count || '-'
    },
  }
}

export const getAlertInfoTableColumn = () => {
  return {
    field: 'alert_info',
    title: i18n.t('system.alert_info'),
    minWidth: 200,
    showOverflow: 'tooltip',
    slots: {
      default: ({ row }, h) => {
        if (!['alert-event', 'alert-ticket'].includes(row.variables?.process_definition_key)) {
          return '-'
        }
        const { resource_type, resource_name } = row.variables
        const config = getWorkflowParamter(row.variables)
        const res_type = config.res_type
        const { strategy } = getStrategyInfo(config.data.alert_details)
        const value = config.data?.value_str
        const ret = []
        if (resource_name) {
          ret.push(<div>{resource_type || res_type ? (i18n.te(`dictionary.${resource_type || res_type}`) ? i18n.t(`dictionary.${resource_type || res_type}`) : resource_type || res_type) : ''}: {resource_name} {i18n.t('system.is_alerting')}, {i18n.t('monitor.text_16')}: {value}</div>)
        }
        if (strategy) {
          ret.push(<div>{i18n.t('monitor.condition')}: {strategy}</div>)
        }
        return ret
      },
    },
  }
}

export const getAlertDetailsTableColumns = (vm, variables, config, resource, alertPolicyData, handleShowAlert) => {
  return [
    {
      field: 'alert_resource',
      title: i18n.t('monitor.text_17'),
      slots: {
        default: ({ row }, h) => {
          let sidePageName = ''
          let resourceName = ''
          const resourceType = variables.resource_type || ''
          const id = variables.resource_id || ''
          const name = variables.resource_name || ''
          if (resourceType && id && name && alertResourceTypeMap[resourceType]) {
            sidePageName = alertResourceTypeMap[resourceType].sidePageName
            resourceName = alertResourceTypeMap[config.res_type].resource
          }
          return [
            <div class='text-truncate'>
              {sidePageName && id && resource ? <side-page-trigger name={sidePageName} id={id} options={{ resource: resourceName }} vm={vm}>{name || '-'}</side-page-trigger> : <span class="mr-2">{name || '-'}</span>}
              {name && <a-button type="link" style={{ height: '16px', lineHeight: '16px' }} onClick={() => vm.handleShowAlert(config)}>{i18n.t('monitor.view_monitor')}</a-button>}
            </div>,
          ]
        },
      },
    },
    getCopyWithContentTableColumn({
      field: 'alert_resource_type',
      title: i18n.t('monitor.text_97'),
      hideField: true,
      message: (row) => {
        return i18n.te(`dictionary.${variables.resource_type}`) ? i18n.t(`dictionary.${variables.resource_type}`) : variables.resource_type || ''
      },
      slotCallback: (row) => {
        return i18n.te(`dictionary.${variables.resource_type}`) ? i18n.t(`dictionary.${variables.resource_type}`) : variables.resource_type || '-'
      },
    }),
    getCopyWithContentTableColumn({
      field: 'alert_resource_id',
      title: i18n.t('table.title.res_id'),
      hideField: true,
      message: (row) => {
        return variables.resource_id || '-'
      },
      slotCallback: (row) => {
        return variables.resource_id || '-'
      },
    }),
    getCopyWithContentTableColumn({
      field: 'ip',
      title: 'IP',
      hideField: true,
      message: () => {
        return resource.ip || ''
      },
      slotCallback: () => {
        return resource.ip || '-'
      },
    }),
    {
      field: 'brand',
      title: i18n.t('compute.text_176'),
      slots: {
        default: ({ row }, h) => {
          let brand = resource.brand
          if (!brand) return [<data-loading />]
          if (brand === 'kvm') brand = 'OneCloud'
          return [
            <BrandIcon name={brand} />,
          ]
        },
      },
    },
    {
      field: 'condition',
      title: i18n.t('monitor.condition'),
      slots: {
        default: ({ row }, h) => {
          if (!config?.data?.alert_details) return '-'
          const { strategy } = getStrategyInfo(config.data.alert_details)

          return [
            <a-tooltip>
              <template slot="title">
                {config.data.metric}
              </template>
              {strategy}
            </a-tooltip>,
          ]
        },
      },
    },
    {
      field: 'value_str',
      title: i18n.t('monitor.text_105'),
      align: 'right',
      formatter: ({ row }) => config.data?.value_str || '-',
    },
    {
      field: 'alert_name',
      title: i18n.t('monitor.text_2'),
      slots: {
        default: ({ row }, h) => {
          if (!config.alert_id) return config.alert_name || '-'
          return [
            <side-page-trigger name="CommonalertsSidePage" id={config.alert_id} options={{ resource: 'commonalerts' }} vm={vm}>{config.alert_name || '-'}</side-page-trigger>,
          ]
        },
      },
    },
    getCopyWithContentTableColumn({
      field: 'alert_id',
      title: i18n.t('monitor.alert_policy_id'),
      hideField: true,
      message: () => {
        return config.alert_id || ''
      },
      slotCallback: () => {
        return config.alert_id || '-'
      },
    }),
    strategyColumn(alertPolicyData?.name ? 'common_alert_metric_details' : 'alert_details', i18n.t('monitor.strategy_detail'), alertPolicyData?.name ? alertPolicyData : config.data),
    getAlertCountTableColumn(),
  ]
}
